export const model = {
    id: null,
    name: "",
    full_name: "",
    code: "",
    status: "",
}